import { type CSSProperties } from 'typestyle/lib/types';

const centerVertical: CSSProperties = {
  height: '100%',
};

export default centerVertical;
